import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';
import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { CmiReportMemberComponent } from './member/cmi-report-member/cmi-report-member.component';
import { CmiReportingComponent } from './member/cmi-reporting/cmi-reporting.component';
import { CmiReportAdminComponent } from './admin/cmi-report-admin/cmi-report-admin.component';
import { CmiReportReadonlyComponent } from './admin/cmi-report-readonly/cmi-report-readonly.component';
import { CmiReportEligibilityComponent } from './admin/cmi-report-eligibility/cmi-report-eligibility.component';
import { CmiReportAdditionComponent } from './admin/cmi-report-addition/cmi-report-addition.component';
import { CmiReportEditorComponent } from './member/cmi-report-editor/cmi-report-editor.component';



@NgModule({
  declarations: [
 
   CmiReportMemberComponent,
   CmiReportingComponent,
   CmiReportAdminComponent,
   CmiReportReadonlyComponent,
   CmiReportEligibilityComponent,
   CmiReportAdditionComponent,
   CmiReportEditorComponent
  
  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class IfscaCmiReportModule { }
